import ComponentBase from 'components/_base/ComponentBase';
import jQuery from 'jquery';
import Handlebars from 'handlebars-template-loader/runtime';
import Clipboard from 'clipboard';
import MeliaHelpers from '../../helpers/MeliaServiceHelper';
import HotelPricesButtons from './hotelPricesButtons/HotelPricesButtons';
import { HOTEL_DETAILS, RESULTS_DESTINATION } from '../../globals/widgetTypes';

const TYPE_NAME_STARS_SELECTOR = 'Establecimiento';

const HotelDetailPanel = ComponentBase.extend({
	template: require('./hotelDetailPanel.hbs'),
	componentClass: 'mainBox-hotel-detail-panel',

	events: {
		'click .cta-see-more-text': 'onClickSeeMoreTextDescription',
		'click .cta-see-less-text': 'onClickSeeLessTextDescription',
		'click .hotel-detail-close-icon': 'onClickOnClose',
		'click .directions-btn': 'onClickDirectionsCTA'
	},

	initialize(options) {
		this.onClose = false;
		this.registerHelperTruncateText();
		if (options.properties.hotelData) {
			this.updateDataHotel(options.properties.hotelData);
		} else {
			this.listenTo(this.bus, 'UPDATED_HOTEL_SELECTED_DATA', hotelData => {
				this.updateDataHotel(hotelData);
			});
		}
		google.maps.event.addDomListener(this.widget.map, 'resize', () => {
			this.setHeight();
		});
		this.clipboardObj = new Clipboard('.share-btn', {
			text: () => {
				this.createMessageControl();
				return this.templateConfig.completeUrl;
			}
		});
		this.listenTo(this.widget.bus, 'HOTEL_CHANGED', (data) => {
			if (this.widget.isMobileVersion && this.hotelData.hotelCode !== data.hotelId) {
				this.parentComponent.collapsePanel();
			}
		});
		this.listenTo(this.widget.bus, 'CURRENCY_CHANGED', currencyData => {
			if (this.hotelData) {
				this.widget.config.currency = currencyData.currency;
				this.widget.config.currencySign = currencyData.currencySign;
				this.widget.config.currencyPrefix = currencyData.currencyPrefix;
				if (currencyData.newPrices &&
					currencyData.newPrices.lowestPrice &&
					currencyData.newPrices.regularPrice) {
						this.hotelData.lowestPrice = currencyData.newPrices.lowestPrice;
						this.hotelData.regularPrice = currencyData.newPrices.regularPrice;
						if (this.isCorrectsPrices(this.hotelData)) {
							this.generatePricesButtons();
						}
				} else {
					MeliaHelpers.getHotelPrices(
						this.widget.config.MeliaUrls,
						this.hotelData.hotelCode,
						this.widget.config.currency,
						this.widget.config.country
						).then(hotelPrices => {
							const jQueryPricesElement = jQuery(hotelPrices);
							const lowestPrice = jQueryPricesElement
							.find('LowestPrice')
							.text();
							const regularPrice = jQueryPricesElement
							.find('RegularPrice')
							.text();			
							this.hotelData.lowestPrice = lowestPrice;
							this.hotelData.regularPrice = regularPrice;
							if (this.isCorrectsPrices(this.hotelData)) {
								this.generatePricesButtons();
							}
						});
					}
				}
		});
	},

    updateDataHotel(hotelData) {
		this.bus.trigger('SELECT_RESULT');
		this.onClose = false;
		if (!hotelData.code || hotelData.hotel) {
			const coordinates = {
				lat: hotelData.hotel.hotelSection.latitudeCoordinates,
				lon: hotelData.hotel.hotelSection.longitudeCoordinates
			};
			if (this.widget.hotelsJson.mainHotel && this.widget.hotelsJson.mainHotel.id !== hotelData.hotel.code) {
				this.centerHotelSelected(coordinates);
			}
			this.hotelData = hotelData.hotel.hotelSection;
		} else {
			this.bus.trigger('UPDATED_HOTEL_SELECTED_DATA', hotelData);

		}
		this.buildData(this.hotelData);
		this.$el.replaceWith(this.render().$el);
		if (this.isCorrectsPrices(this.hotelData)) {
			this.generatePricesButtons();
		}
		this.setHeight();
		this._hideElemByWidget();
		this.bus.trigger('UPDATED_MARKERS',this);

	},
	isCorrectsPrices(hotelData) {
		const pricesAreNull = hotelData.lowestPrice === null || hotelData.regularPrice === null;
		const pricesAreUndefined = hotelData.lowestPrice === undefined || hotelData.regularPrice === undefined;
		const pricesAreZeroNumber = hotelData.lowestPrice === 0 || hotelData.regularPrice === 0;
		const pricesAreZeroString = hotelData.lowestPrice === '0' || hotelData.regularPrice === '0';
		const pricesAreEmptyString = hotelData.lowestPrice === '' || hotelData.regularPrice === '';
		return !pricesAreNull &&
			!pricesAreUndefined &&
			!pricesAreZeroNumber &&
			!pricesAreZeroString &&
			!pricesAreEmptyString;
	},
	generatePricesButtons() {
		if (this.pricesButtons) {
			this.pricesButtons.updateContent(this.hotelData);
		} else {
			this.pricesButtons = new HotelPricesButtons({
				position: 'hotel-prices-buttons',
				componentConstructorClass: 'HotelPricesButtons',
				identifier: 'HotelPricesButtons',
				map: this.widget.map,
				widget: this.widget,
				isChild: true,
				parent: this,
				properties: {
					hotelData: this.hotelData,
					isMobile: this.widget.isMobileVersion
				}
			});
		}
		this.$el.find('.hotel-prices').append(this.pricesButtons.el);
	},
	_hideElemByWidget(){
		if (this.widget.typeWidget === RESULTS_DESTINATION && this.widget.isMobileVersion) {
			this.$el.find('.hotel-prices').addClass('price-detail-disabled');
		}
	},
    _createRefHotel(pos, item) {
        let bus = this.bus;
        let config = {
            position: pos,
            sender: this,
            properties: item
        };

        let icon = 'secondary-hotel-marker.svg';
        this.widget.config.genericIconMarker = icon;
        bus.trigger('CREATE_POINT_REFERENCE', config);
    },

    buildData(hotelData) {
		
        const {
			description,
            address,
            title,
            imgDetail,
            categories,
            url
		} = hotelData;
		
        this.templateConfig = {
            address,
            descriptionToTruncate: this.combineParagraph(description),
            allDescription: description,
            title,
            imgDetail,
            stars: this.getArrayNumberOfStars(categories),
            isMobile: this.widget.isMobileVersion,
            completeUrl: `${this.widget.config.MeliaUrls.baseUrl || 'https://www.melia.com'}${url}`,
			showCloseBtn: this.widget.isMobileVersion || this.widget.typeWidget !== HOTEL_DETAILS,
			showDirectionsBTN: [HOTEL_DETAILS, RESULTS_DESTINATION].includes(this.widget.typeWidget),
        };
    },

    centerHotelSelected(item){
        let location = new google.maps.LatLng(item.lat, item.lon);
        if(this.map.getZoom() !== this.widget.config.defaultView.zoom) {
            this.map.setZoom(this.widget.config.defaultView.zoom);
        }
        this.map.setCenter(location);
        if (this.widget.typeWidget !== RESULTS_DESTINATION) {
            this.map.setZoom(15);
        }
    },

	onClickSeeMoreTextDescription() {
		this.$el.find('.description-text').show();
		this.$el.find('.description-truncate').hide();
		this.$el.find('.cta-see-more-text').hide();
		this.$el.find('.cta-see-less-text').show();
	},

	onClickSeeLessTextDescription() {
		this.$el.find('.description-text').hide();
		this.$el.find('.description-truncate').show();
		this.$el.find('.cta-see-more-text').show();
		this.$el.find('.cta-see-less-text').hide();
	},

	combineParagraph(description) {
		let text = '';
		jQuery(description).each((index, element) => {
			text += jQuery(element).text();
		});
		return text;
	},

	setHeight() {
		if (!this.onClose){
            const widgetHeight = this.widget.getHeight();
            const heightAutocomplete = 50;
            const marginTopMainPanel = 10;
            const googleLogoHeight = 28;
            if (!this.widget.isMobileVersion) {
                this.$el.css(
                    'max-height',
                    `${widgetHeight -
                    heightAutocomplete -
                    marginTopMainPanel -
                    googleLogoHeight}px`
                );
            }
		}

	},
	onClickOnClose() {
		this.onClose = true;
        if (this.widget.isMobileVersion) {
            this.parentComponent.collapsePanel();
        } else {
            this.hide();
        }
	},

	onClickDirectionsCTA() {
		if (this.widget.isMobileVersion) {
			this.parentComponent.collapsePanel();
		}
		const openDirectionBox = true;
		this.bus.trigger('directions_btn_event', openDirectionBox, this.hotelData);
	},

	registerHelperTruncateText() {
		Handlebars.registerHelper('trimString', function(
			passedString,
			start,
			length
		) {
			if (passedString) {
				let mlength = length,
					preS = '',
					tailS = '';
				if (start > 0 && passedString.length > 3) {
					preS = '...';
					mlength = length - 3;
				}
				if (passedString.length > start + length) {
					tailS = '...';
					mlength = mlength - 3;
				}
				const theString = preS + passedString.substr(start, mlength) + tailS;
				return new Handlebars.SafeString(theString);
			}
		});
	},

	createMessageControl() {
		const typeIcon = 'success';
		const text = this.widget.polyglot.t('hotelDetail.successCopy');
		const autoHideTime = 2500;
		const canRepeat = false;
		this.widget.messageControl.createMessage(
			typeIcon,
			text,
			autoHideTime,
			canRepeat
		);
	},

	getArrayNumberOfStars(categories) {
		const starsObj = categories.find(e => {
			return e.type === TYPE_NAME_STARS_SELECTOR;
		});
		const nStars = starsObj ? parseInt(starsObj.description.substr(0, 1)) : 0;
		return [...Array(nStars)];
	}
});
export default HotelDetailPanel;



// WEBPACK FOOTER //
// ./src/components/hotelDetailPanel/HotelDetailPanel.js